import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseApiTemplateService, Core2Config, ApiVisa } from "../../shared";
import { BudgetItemContainerModel } from "../../../../../../models/aggregates/erp/financial/budget-item-container.model";

@Injectable({
  providedIn: "root",
})
export class BudgetItemService extends BaseApiTemplateService<BudgetItemContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      Core2Config.FI_PREFIX +
      "budget-items/backoffice-ep";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      Core2Config.FI_PREFIX +
      "budget-items/backoffice-ep";
    this.httpClient = http;
  }
}
